import { AccordionButton, Box, Heading, Radio } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';

type HeaderProps = {
  name: string;
  title: string;
  isExpanded: boolean;
  children: React.ReactElement;
};

export const AccordionHeader = ({
  name,
  title,
  isExpanded,
  children,
}: HeaderProps) => (
  <AccordionButton className={cx('TabButton')}>
    <>
      <Box as="span" flex="1" textAlign="left">
        <Radio value={name} isChecked={isExpanded}>
          <Heading variant="h2">{title}</Heading>
        </Radio>
      </Box>
      {children}
    </>
  </AccordionButton>
);
